import React from "react";
import { recentReviews } from "../mock";
import { Star } from "lucide-react";

export default function RecentReviews() {
  return (
    <section className="section bg-[#F5EFE6]">
      <div className="container-y">
        <div className="text-center mb-12">
          <p className="font-sans-y text-[11px] tracking-[0.3em] uppercase text-[#C9A961] mb-3">
            Verified buyers
          </p>
          <h2 className="font-serif-y text-3xl md:text-5xl text-[#1a1a1a]">Recent Reviews</h2>
        </div>

        <div className="flex gap-5 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-4 -mx-5 px-5">
          {recentReviews.map((r, i) => (
            <div
              key={i}
              className="snap-start shrink-0 w-[300px] md:w-[340px] bg-white p-6 border border-[#EAE3D8] flex flex-col gap-4"
            >
              <div className="flex items-center gap-4">
                <img
                  src={r.img}
                  alt={r.product}
                  className="w-16 h-16 object-cover bg-[#F5EFE6]"
                  loading="lazy"
                />
                <div className="flex-1">
                  <div className="flex items-center gap-0.5 mb-1">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={10} fill="#C9A961" color="#C9A961" />
                    ))}
                  </div>
                  <p className="font-sans-y text-[10px] tracking-[0.15em] uppercase text-[#7a7a7a]">
                    {r.date}
                  </p>
                </div>
              </div>
              <h4 className="font-serif-y text-[17px] text-[#1a1a1a] leading-snug">{r.title}</h4>
              <p className="font-sans-y text-[13px] text-[#555] leading-relaxed line-clamp-4">
                {r.text}
              </p>
              <div className="mt-auto pt-3 border-t border-[#EAE3D8]">
                <p className="font-sans-y text-[12px] text-[#1a1a1a] font-semibold">{r.author}</p>
                <p className="font-sans-y text-[11px] text-[#7a7a7a] mt-0.5 line-clamp-1">
                  {r.product}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
